import {
    AppBar,
    Box,
    Button,
    IconButton,
    Toolbar,
    Typography
} from '@mui/material';
import { ArrowLeftLinearIcon } from '../../../../../../icons-lib';
import React from 'react';

export const CustomToolbar = ({ title, actions, handleBack }) => {
    return (
        <AppBar
            position="static"
            color="default"
            sx={{
                boxShadow: 0,
                mb: 4,
                borderBottom: 1,
                borderColor: 'divider'
            }}
        >
            <Toolbar
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap'
                }}
            >
                <Box display={'flex'} alignItems={'center'}>
                    <IconButton
                        sx={{ borderRadius: '8px', mr: 1 }}
                        onClick={() => handleBack()}
                    >
                        <ArrowLeftLinearIcon />
                    </IconButton>
                    <Typography variant="h6">{title}</Typography>
                </Box>
                <Box>
                    {actions.map((action, index) => (
                        <Button
                            key={index}
                            variant="outlined"
                            color="primary"
                            onClick={action.onClick}
                            startIcon={action.icon}
                            sx={{ mr: 1 }}
                        >
                            {action.title}
                        </Button>
                    ))}
                </Box>
            </Toolbar>
        </AppBar>
    );
};
